'use client'

import type {
  GyymRequest,
  GyymResponse,
  HttpError,
  InferGyymRequestParams,
} from '@gyym/sdk'
import useSWR, { type SWRConfiguration, SWRResponse } from 'swr'

type FetchConfig<
  T extends GyymRequest,
  Params extends InferGyymRequestParams<T> = InferGyymRequestParams<T>,
> = Params extends never ? T : Params['length'] extends 0 ? T : [T, ...Params]

export const useGyymSWR = <T extends GyymRequest = GyymRequest>(
  config: FetchConfig<T> | null,
  options?: SWRConfiguration,
) => {
  const [request, ...params] = config
    ? Array.isArray(config)
      ? config
      : ([config] as [T])
    : []

  return useSWR(
    request?.getKey(...params),
    (): GyymResponse<T> => request?.(...params),
    options,
  ) as SWRResponse<GyymResponse<T>, HttpError>
}
